import * as Yup from "yup";

export const validationSchema = Yup.object({
	name: Yup.string().min(1, "Минимум 1 символ").required("Поле обязательно"),
	source: Yup.string().min(3, "Минимум 3 символа").required("Поле обязательно"),
	robotId: Yup.string(),
	endpointId: Yup.string(),
	timeintervals: Yup.array().of(Yup.string()),
});
